// @flow
import * as React from 'react';

import { selectGrid } from '@gandi/billing';
import { selectAllCartBundleGrids } from '@gandi/cart';
import { useTranslator } from '@gandi/translate';
import { Base } from '@gandi/ui';

import { useAppSelector } from 'src/hooks/useAppSelector';
import { selectShopCurrent } from 'src/modules/organization/selectors';

function IncompatibleBundleGrid(): React.MixedElement | null {
  const { __ } = useTranslator();

  const currentOrg = useAppSelector(state => selectShopCurrent(state, true));
  const sharingIdProps = React.useMemo(
    () => ({ sharingId: currentOrg?.id }),
    [currentOrg?.id],
  );
  const grid = useAppSelector(state => selectGrid(state, sharingIdProps));

  const bundleGrids = useAppSelector(selectAllCartBundleGrids);

  const hasIncompatibleBundleGrid =
    Array.isArray(bundleGrids) &&
    bundleGrids.length > 0 &&
    !bundleGrids.includes(grid);

  if (!hasIncompatibleBundleGrid) return null;

  return (
    <Base
      tagName="p"
      marginTop="none"
      marginBottom="base"
      padding="small"
      backgroundColor="surface"
    >
      {__(
        'Because this organization already has a special price rate on domain name purchases, additional domain bundle prices do not apply.',
      )}
    </Base>
  );
}

export default (IncompatibleBundleGrid: React.ComponentType<{}>);
